import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SEOOptimizedEcommerceWebsitesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="SEO-Optimized E-commerce Websites in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Rank Higher, Sell More</Subheading>}
        heading={
          <Heading>
            SEO-Optimized <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we create SEO-optimized e-commerce websites in
            **Dubai International Financial Centre (DIFC)** that drive traffic,
            boost rankings, and maximize sales. Our solutions blend cutting-edge
            SEO strategies with stunning design to grow your online presence.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1661956602944-249bcd04b63f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1523289333742-be1143f6b766?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Optimize Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="SEO Excellence in DIFC"
        description="We build e-commerce websites that dominate search results."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "SEO Expertise",
            description: "Proven strategies by certified specialists.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Higher Conversions",
            description: "Optimized pages that drive sales.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Visibility",
            description: "Rank higher on Google and beyond.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Performance",
            description: "Speed-optimized for SEO and UX.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile SEO",
            description: "Responsive designs for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred by DIFC’s top businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our SEO Optimization Process"
        description={
          <Description>
            We craft SEO-optimized e-commerce websites with a strategic
            approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Analyze keywords and competitors.</li>
              <li>Design: Create SEO-friendly layouts.</li>
              <li>Development: Build with technical SEO in mind.</li>
              <li>Optimization: Enhance content and metadata.</li>
              <li>Launch: Deploy a high-ranking store.</li>
              <li>Support: Monitor and refine SEO performance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="SEO Success in DIFC"
        description="Our SEO-optimized websites deliver results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "Top rankings drove higher revenue.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Traffic Surge",
            description: "Increased organic visits for a DIFC store.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "Trusted for SEO excellence in DIFC.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Rank?</Subheading>}
        heading="SEO-Optimized E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for SEO-optimized e-commerce websites in
            DIFC. Build a high-ranking, high-performing store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607083206968-13611e3d76db?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
